import firebase from '../../firebase/compat'

// Client wrapper om de super-admin-gated `getInsightCells` Cloud Function:
// de ISS 2.0-celdocumenten (Insight Strength Score) van één MSI-effect.
// Curatiewaarborg (b): statistische parameters worden uit deze
// scoredocumenten gerenderd, nooit uit de (herschreven) redactietekst.
//
// AI-CONTEXT: See docs/features/insight-strength-score-2.md

// De classificatietabellen staan in een eigen, import-vrij bestand zodat de
// pariteitswacht in functions/ ze kan inlezen zonder over `firebase` te
// struikelen. Hier doorgegeven zodat bestaande afnemers niets hoeven te wijzigen.
export { ISS_CLASSIFICATION_LABELS, ISS_EXTERNAL_CLASSIFICATIONS } from './issClassifications'

/**
 * Haal ISS 2.0-celdocumenten op. Zonder `msiId` komen álle cellen van de
 * huidige ISS-versie terug (voor het per-effect stoplicht op de monitor-kaart).
 *
 * `herberekeningNodig: true` betekent dat er wél cellen bestaan, maar onder een
 * OUDERE methodiekversie: er is net een versiebump geweest en de nachtelijke
 * run (05:00) moet nog draaien. `cells: []` betekent dan iets anders dan "niets
 * gevonden" — toon geen afwezigheid die er niet is.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 *
 * @param {{ msiId?: string }} [args]
 * @returns {Promise<{version: string, cells: Array<object>, herberekeningNodig: boolean}>}
 */
export const fetchInsightCells = async ({ msiId } = {}) => {
    const callable = firebase.app().functions('europe-west1').httpsCallable('getInsightCells')
    const result = await callable(msiId ? { msiId } : {})
    return result.data
}

export default fetchInsightCells
